/**
 * @generated SignedSource<<de3049999986b77d612a640dd20fc008>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSidebarBuyerIncentives_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDibsPromiseModalLazy_user">;
  readonly " $fragmentType": "PdpSharedSidebarBuyerIncentives_user";
};
export type PdpSharedSidebarBuyerIncentives_user$key = {
  readonly " $data"?: PdpSharedSidebarBuyerIncentives_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSidebarBuyerIncentives_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSidebarBuyerIncentives_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDibsPromiseModalLazy_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2dcfff6eb4fc584b35e66b03bb0cf6eb";

export default node;
